import './PeriscopePagination.scss';
import { Pagination } from 'antd';
import React, { useCallback } from 'react';
function getScrollableElement(element) {
    if (!element) {
        return null;
    }
    if (element && element.scrollTop) {
        return element;
    }
    for (let i = 0; i < element.children.length; i++) {
        const child = element.children[i];
        const result = getScrollableElement(child);
        if (result) {
            return result;
        }
    }
    return null;
}
export const paginationDefaultQueryParams = {
    count: 20,
    offset: 0
};
export const paginationFallbackQueryParams = {
    offset: 0
};
export const PeriscopePagination = ({ loading, onChange, queryParams, scrollRef, totalCount }) => {
    var _a, _b;
    const handlePaginationChange = useCallback((page, pageSize) => {
        onChange({
            count: pageSize,
            offset: (page - 1) * pageSize
        });
        setTimeout(() => {
            if (scrollRef.current) {
                const target = getScrollableElement(scrollRef.current);
                if (target) {
                    target.scrollTop = 0;
                }
            }
        }, 250);
    }, [onChange, scrollRef]);
    if (loading) {
        return null;
    }
    const offset = (_a = queryParams.offset) !== null && _a !== void 0 ? _a : paginationDefaultQueryParams.offset;
    const pageSize = (_b = queryParams.count) !== null && _b !== void 0 ? _b : paginationDefaultQueryParams.count;
    const page = offset < pageSize ? 1 : Math.ceil((offset + 1) / pageSize);
    const hideOnSinglePage = totalCount <= pageSize;
    return (React.createElement("div", { className: 'periscope-field-list-paginator' },
        React.createElement(Pagination, { current: page, hideOnSinglePage: hideOnSinglePage, onChange: handlePaginationChange, pageSize: pageSize, showSizeChanger: true, total: totalCount })));
};
